<script setup>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip
)

defineProps({
  data: {
    type: Object,
    required:  true
  }
})

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true
    },
    tooltip: {
      enabled: true
    }
  },
  scales: {
    y:  {
      display: false,
      beginAtZero: true
    },
    x: {
      display: true,
      grid: {
        display: false,        // coupe les gridlines de l’axe X [web:93]
        drawOnChartArea: false, // évite les traits verticaux dans la zone du chart [web:136]
        drawTicks: false        // évite les petits traits (ticks) sous les labels [web:93]
      },
      border: {
        display: false          // coupe la ligne de l’axe (bordure) [web:93]
      },
    }
  }
}
</script>

<template>
  <Bar v-if="data" :data="data" :options="options" />
</template>
